module.exports = __webpack_public_path__ + "pbj.png?88ad217be25950b3359aaf1f3bfae8df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/pbj.png
// module id = 127
// module chunks = 0